<template>
    <!--below added by Alex-->
    <loading v-model:active="isLoading" :can-cancel="canCancel" :on-cancel="whenCancelled" :is-full-page="fullPage"
        :height="height" :width="width" :color="color" :loader="loader" :background-color="bgColor">
        <template #default v-if="useSlot">
            <h3>Loading ...</h3>
        </template>
    </loading>
    <!--above added by Alex-->
    <Card class="dialog" v-if="!isLoading">
        <template #title>
            Projects
            <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                style="position:fixed;right:10px" @click="close()" aria-label="Close" />
            <p class="p-component" style="margin-bottom: -13px; margin-top: 7px;">
                Projects in your organization. Open a project from the list to edit, or create a new project, or copy an
                existing project.</p>
        </template>

        <template #content>

            <TabView v-model:activeIndex="activeIndex">
                <TabPanel v-if="!isAdmin">
                    <template #header>
                        <span>Your Projects</span>
                    </template>
                    <span class="p-input-icon-left" style="width:100%;margin-bottom: 10px;">
                        <i class="pi pi-search" />
                        <InputText v-model="searchProject" placeholder="Search" style="width:100%">
                        </InputText>
                    </span>
                    <DataTable
                        :value="projects.filter(p => searchProject == '' || p.projectTitleWithoutVersion.toLowerCase().includes(searchProject.toLowerCase()))"
                        class="p-datatable-sm" :scrollable="true" scrollHeight="250px" sortField="modifiedAt"
                        :sortOrder="-1">
                        <template #empty>
                            No projects found.
                        </template>
                        <Column field="projectTitleWithoutVersion" header="Name" style="min-width:40%" :sortable="true">
                        </Column>
                        <Column field="versions" header="Version" style="min-width:60px">
                            <template #body="slotProps">
                                <Dropdown v-model="slotProps.data.selectedVersion" :options="slotProps.data.versions"
                                    optionLabel="version" style="height: 27.5px;width:100%">
                                </Dropdown>
                            </template>
                        </Column>
                        <Column field="selectedVersion.project.owner" header="Owner" style="min-width:10%"
                            :sortable="true">
                        </Column>
                        <Column field="selectedVersion.project.mainContractor" header="Main Contractor"
                            style="min-width:17%" :sortable="true">
                        </Column>
                        <Column field="selectedVersion.project.modifiedAt" header="Last Modified" style="min-width:10%"
                            :sortable="true">
                            <template #body="slotProps">
                                <label>{{ getDateString(slotProps.data.selectedVersion.project.modifiedAt) }}</label>
                            </template>
                        </Column>
                        <Column field="selectedVersion.project.submitted" header="Submitted" style="min-width:80px"
                            :sortable="true">
                            <template #body="slotProps">
                                <i v-if="slotProps.data.selectedVersion.project.submitted"
                                    class="pi pi-check p-button-success"></i>
                                <i v-else class="pi pi-minus"></i>
                            </template>
                        </Column>
                        <Column header="" style="min-width:35px">

                            <template #body="slotProps">
                                <div v-tooltip="`Opened by ${slotProps.data.selectedVersion.project.openedBy}`"
                                    v-if="slotProps.data.selectedVersion.project.locked">
                                    <Button icon="pi pi-lock" class="p-button-rounded p-button-secondary p-button-text"
                                        disabled aria-label="Locked Project" />
                                </div>
                                <Button :icon="slotProps.data.selectedVersion.project.openingReadonly"
                                    aria-label="Open project to view"
                                    class="p-button-rounded p-button-secondary p-button-text"
                                    @click.prevent="openProject(slotProps.data.selectedVersion.project, false)"
                                    v-tooltip="'Open project to view'"
                                    v-else-if="slotProps.data.selectedVersion.project.readonlyUserIds.includes(getUser.id) || slotProps.data.selectedVersion.project.submitted" />
                                <!--below modified by Alex-->
                                <Button :icon="slotProps.data.selectedVersion.project.opening"
                                    aria-label="Open project to edit"
                                    class="p-button-rounded p-button-secondary p-button-text"
                                    @click.prevent="openProject(slotProps.data.selectedVersion.project, false)"
                                    v-tooltip="'Open project to edit'" v-else />
                                <!--above modeified by Alex-->
                            </template>
                        </Column>
                        <Column header="" style="min-width:35px">
                            <template #body="slotProps">
                                <Button icon="pi pi-save" class="p-button-rounded p-button-secondary p-button-text"
                                    aria-label="Save as new project" @click="display = true;

                                    projectName = `${slotProps.data.selectedVersion.project.projectTitleWithoutVersion} - Copy`;
                                    projectVersion = slotProps.data.selectedVersion.version === '-' ? 1 : Number(slotProps.data.selectedVersion.version) + 1;
                                    targetProject = slotProps.data.selectedVersion.project;"
                                    v-tooltip="'Save as new project'"
                                    v-if="slotProps.data.selectedVersion.project.adminUserIds.includes(getUser.id) || slotProps.data.selectedVersion.project.memberUserIds.includes(getUser.id)" />
                            </template>
                        </Column>
                        <Column header="" style="min-width:35px">
                            <template #body="slotProps">
                                <Button :icon="slotProps.data.selectedVersion.project.deleting" aria-label="Delete"
                                    class="p-button-rounded p-button-danger p-button-text"
                                    @click="targetProject = slotProps.data.selectedVersion.project; confirmDeleteProject($event);"
                                    v-tooltip="'Delete'"
                                    v-if="getUser.id == slotProps.data.selectedVersion.project.ownerUserId" />
                            </template>
                        </Column>
                    </DataTable>
                </TabPanel>
                <TabPanel :header="isAdmin ? 'Submitted Projects' : 'District Projects'"
                    v-if="getUser.userType == 'epd' || isAdmin">
                    <DataTable :value="districtProjects" class="p-datatable-sm" :scrollable="true" scrollHeight="250px"
                        sortField="modifiedAt" :sortOrder="-1">
                        <template #empty>
                            No projects found.
                        </template>
                        <Column field="projectTitleWithoutVersion" header="Name" style="min-width:35%" :sortable="true">
                        </Column>
                        <Column field="versions" header="Version" style="min-width:60px">
                            <template #body="slotProps">
                                <Dropdown v-model="slotProps.data.selectedVersion" :options="slotProps.data.versions"
                                    optionLabel="version" style="height: 27.5px;width:100%">
                                </Dropdown>
                            </template>
                        </Column>
                        <Column field="selectedVersion.project.owner" header="Owner" style="min-width:15%"
                            :sortable="true">
                        </Column>
                        <Column field="selectedVersion.project.mainContractor" header="Main Contractor"
                            style="min-width:17%" :sortable="true">
                        </Column>
                        <Column field="selectedVersion.project.modifiedAt" header="Last Modified" style="min-width:14%"
                            :sortable="true">
                            <template #body="slotProps">
                                <label>{{ getDateString(slotProps.data.selectedVersion.project.modifiedAt) }}</label>
                            </template>
                        </Column>
                        <Column header="" style="min-width:35px">
                            <template #body="slotProps">
                                <Button :icon="slotProps.data.selectedVersion.project.opening" aria-label="Open"
                                    class="p-button-rounded p-button-secondary p-button-text"
                                    @click="openProject(slotProps.data.selectedVersion.project, true)"
                                    v-tooltip="'Open'" />
                            </template>
                        </Column>
                    </DataTable>
                </TabPanel>
            </TabView>
        </template>
        <template #footer>
            <div class="formgrid grid">
                <div class="field col-12">
                    <Button label="New Project" icon="pi pi-plus" @click="setProject()" />
                </div>
            </div>
        </template>
    </Card>
    <ConfirmPopup>
        <template #message="slotProps">
            <div class="flex p-4">
                <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
                <p style="margin:0px 5px">Do you want to <b style="color:#c02929">PERMANENT DELETE</b> this project?</p>
            </div>
        </template>
    </ConfirmPopup>
    <Dialog header="Save as" v-model:visible="display" :modal="true">
        <TabView v-model:activeIndex="activeIndex">
            <TabPanel header="New Version">
                <span class="p-float-label col-12" style="width:325px;height: 50px;">
                    <label for="projectVersion" style="padding-left: 5px;">New Version Number: {{ projectVersion
                    }}</label>
                </span>
                <div style="text-align: center;margin-top: 10px;">
                    <Button label="Save as New Version" :icon="saving" @click="saveAsNewProject(true)"></Button>
                </div>
            </TabPanel>
            <TabPanel header="New Project">
                <span class="p-float-label col-12" style="margin-top:15px">
                    <InputText id="projectName" type="text" v-model="projectName" style="width:300px" />
                    <label for="projectName" style="padding-left: 5px;">New Project Name</label>
                </span>
                <div style="text-align: center;margin-top: 10px;">
                    <Button label="Save as New Project" :icon="saving" @click="saveAsNewProject(false)"></Button>
                </div>
            </TabPanel>
            <!-- <TabPanel header="Copy to Production Server">
                <div style="text-align: center;margin-top: 10px;">
                    <Button label="Copy to Production Server" :icon="saving" @click="copyToProduction()"></Button>
                </div>
            </TabPanel> -->
        </TabView>
    </Dialog>
</template>

<script>
import { ref, reactive } from 'vue';
import MapOL from "@/libs/myOpenLayers.js";
import DateHelper from '@/helper/DateHelper';
import { defineComponent } from 'vue'; //added by Alex
import Loading from '../../index'; //added by Alex


export default {
    name: 'Projects',
    props: {
        projects: Object,
        districtProjects: Object
    },
    //below added by Alex
    components: {
        Loading
    },
    //above added by Alex
    setup() {

    },
    data() {
        return {
            // below Alex
            isLoading: false,
            fullPage: true,
            canCancel: true,
            useSlot: false,
            loader: 'bars',
            color: '#00632C',
            bgColor: '#ffffff',
            height: 128,
            width: 128,
            //above Alex
            targetProject: null,
            display: false,
            projectName: "",
            projectVersion: "",
            saving: "pi pi-save",
            searchProject: ""
        }
    },
    computed: {
        getUser() {
            return this.$store.getters.currentUser;
        },
        isAdmin() {
            return this.$store.getters.currentUser?.userType == "admin";
        },
    },
    methods: {
        close() {
            this.$router.replace({ path: '/' });
        },
        setProject(project, readonly) {
            MapOL.clearForNew();
            this.$emit('setProject', project);
        },
        openProject(project, readonly) {
            let props = this;
            project.opening = "pi pi-spin pi-spinner";
            project.openingReadonly = "pi pi-spin pi-spinner";
            readonly = project.readonlyUserIds.includes(this.$store.getters.currentUser.id) || readonly;
            if (props.$store.getters.currentProject?.id) {
                props.axios
                    .post(`${props.apiEndpoint}project/close?id=${props.$store.getters.currentProject.id}`)
            }
            props.axios
                .get(`${props.apiEndpoint}project?id=${project.id}&userId=${readonly ? 0 : props.$store.getters.currentUser.id}`)
                .then(response => {
                    // console.log("project.id awal");
                    // console.log(project.id);
                    if (response.data.ismultipolygon === 1) {
                        MapOL.setIsMultipolygon(true);
                    } else {
                        MapOL.setIsMultipolygon(false);
                    }
                    MapOL.openProjectGISData(project.id); //##### ===> try test to move this after MapOL.setProjectObject(project); so that the global projectObj on myopenlayer exist before calculate noise.
                    response.data = DateHelper.fixUTCDate(response.data);
                    response.data.equipments.forEach(e => {
                        e.pme = e.officialId != "" ? `${e.officialId} - ${e.otherName}` : e.otherName;
                    })
                    response.data.equipments = response.data.equipments.filter(e =>
                        response.data.tasks.filter(t => t.id == e.task && t.group == e.group && t.zone == e.zone).length > 0
                    )
                    response.data.readonly = readonly || response.data.submitted;
                    props.$store.dispatch('setCurrentProject', { project: response.data });
                    props.$store.commit('setProjectId', { value: project.id });
                    project.opening = "pi pi-folder-open";
                    project.openingReadonly = "pi pi-eye";
                    props.jesus(); //modified by Alex
                    MapOL.setProjectObject(response.data);
                    //MapOL.openProjectGISData(project.id); //##### ===> try test to move this after MapOL.setProjectObject(project); so that the global projectObj on myopenlayer exist before calculate noise.

                    console.log("project.id edua");
                    console.log(project.id);
                    console.log("project");
                    console.log(project);
                    console.log("response.data");
                    console.log(response.data);


                })
                .catch(error => { project.opening = "pi pi-folder-open"; project.openingReadonly = "pi pi-eye"; })

            // this.jesus();
        },
        jesus() {
            if (!this.$store.getters.currentProject?.isCalculated) { this.close(); return; };
            this.isLoading = true; //added by Alex
            let props = this;
            //below added by Alex
            MapOL.hyun(props.$store.getters.currentProject);
            var jacob = MapOL.getIsCalculatedForVue2(props.$store.getters.currentProject);
            let timerId = setInterval(() => {

                console.log("run every 2 seconds");
                jacob = MapOL.getIsCalculatedForVue2(props.$store.getters.currentProject);
                if (jacob == 1) {
                    clearInterval(timerId);
                    this.isLoading = false;
                    props.close();
                }
            }, 2000);
            //Unconditionally stop after 20 minutes: modified by Alex Feb 22
            setTimeout(() => { clearInterval(timerId); this.isLoading = false; }, 1200000); // modified by Alex Feb 22
            return timerId;

            //above added by Alex
        },
        //below Alex 
        whenCancelled() {
            clearTimeout();
            console.log("User cancelled the loader.")
        },
        //above Alex
        saveAsNewProject(isNewVersion) {
            let props = this;
            this.saving = "pi pi-spin pi-spinner";
            this.axios
                .get(`${this.apiEndpoint}project?id=${props.targetProject.id}`)
                .then(response => {
                    //MapOL.openProjectGISData(props.targetProject.id); 
                    let sourceProjectId = props.targetProject.id;
                    response.data = DateHelper.fixUTCDate(response.data);
                    response.data.equipments.forEach(e => {
                        e.pme = e.officialId != "" ? `${e.officialId} - ${e.otherName}` : e.otherName;
                    })
                    response.data.equipments = response.data.equipments.filter(e =>
                        response.data.tasks.filter(t => t.id == e.task && t.group == e.group && t.zone == e.zone).length > 0
                    )
                    let newProject = response.data;
                    props.updateProjectDate(newProject);
                    newProject.submitted = false;
                    newProject.ownerUserId = props.$store.getters.currentUser.id;
                    newProject.openedBy = props.$store.getters.currentUser.id;
                    newProject.adminUserIds = [props.$store.getters.currentUser.id]
                    newProject.tasks.forEach(t => {
                        if (!t.start && !t.end) {
                            t.start = DateHelper.getDateString(new Date());
                            t.end = DateHelper.getDateString(new Date());
                        }
                        if (t.end == null || !t.end) {
                            t.end = t.start;
                        }
                        if (t.start == null || !t.start) {
                            t.start = t.end;
                        }
                    })
                    newProject.id = undefined;
                    newProject.projectTitle = isNewVersion ? `${newProject.projectTitle.split("@")[0]}@${props.projectVersion}` : props.projectName;
                    newProject.equipments = []; // let copy geo handle equipment
                    console.log("newProject");
                    console.log(newProject);
                    props.axios
                        .get(`${props.apiEndpoint}project/selectednsr/${props.targetProject.id}`).then(response => {
                            newProject.selectednsr = response.data;
                            console.log(newProject);

                            props.axios
                                .post(`${props.apiEndpoint}project`, DateHelper.fixUTCDate(newProject))
                                .then(function (response) {
                                    let targetProjectId = response.data.id;
                                    newProject.id = targetProjectId;
                                    props.axios
                                        .post(`${props.apiEndpoint}project/selectednsr`, DateHelper.fixUTCDate(newProject))
                                        .then(function (response) {

                                            props.axios
                                                .post(`${props.apiEndpoint}project/copygeom/${sourceProjectId}/${targetProjectId}`)
                                                .then(function (response) {
                                                    console.log("Copy geometry result = ", response);
                                                    //refresh project id
                                                    props.axios
                                                        .get(`${props.apiEndpoint}project?id=${targetProjectId}`)
                                                        .then(response => {
                                                            if (response.data.ismultipolygon === 1) {
                                                                MapOL.setIsMultipolygon(true);
                                                            } else {
                                                                MapOL.setIsMultipolygon(false);
                                                            }
                                                            MapOL.openProjectGISData(targetProjectId);
                                                            response.data = DateHelper.fixUTCDate(response.data);
                                                            response.data.equipments.forEach(e => {
                                                                e.pme = e.officialId != "" ? `${e.officialId} - ${e.otherName}` : e.otherName;
                                                            })
                                                            response.data.equipments = response.data.equipments.filter(e =>
                                                                response.data.tasks.filter(t => t.id == e.task && t.group == e.group && t.zone == e.zone).length > 0
                                                            )
                                                            response.data.readonly = response.data.submitted;
                                                            props.$store.dispatch('setCurrentProject', { project: response.data });
                                                            props.$store.commit('setProjectId', { value: targetProjectId });
                                                            console.log("project");
                                                            console.log(response.data);
                                                            MapOL.setProjectObject(response.data);
                                                            props.display = false;
                                                            props.close();
                                                        })
                                                })
                                                .catch(error => console.log(error))
                                        })
                                        .catch(error => console.log(error))
                                })
                                .catch(error => console.log(error))
                        })
                        .catch(error => console.log(error))
                })
                .catch(error => { console.log(error) })
        },
        copyToProduction() {
            let props = this;
            this.saving = "pi pi-spin pi-spinner";
            this.axios
                .get(`${this.apiEndpoint}project?id=${props.targetProject.id}`)
                .then(response => {
                    //MapOL.openProjectGISData(props.targetProject.id); 
                    let sourceProjectId = props.targetProject.id;
                    response.data = DateHelper.fixUTCDate(response.data);
                    response.data.equipments.forEach(e => {
                        e.pme = e.officialId != "" ? `${e.officialId} - ${e.otherName}` : e.otherName;
                    })
                    response.data.equipments = response.data.equipments.filter(e =>
                        response.data.tasks.filter(t => t.id == e.task && t.group == e.group && t.zone == e.zone).length > 0
                    )
                    let newProject = response.data;
                    props.updateProjectDate(newProject);
                    newProject.submitted = false;
                    newProject.ownerUserId = props.$store.getters.currentUser.id;
                    newProject.tasks.forEach(t => {
                        if (!t.start && !t.end) {
                            t.start = DateHelper.getDateString(new Date());
                            t.end = DateHelper.getDateString(new Date());
                        }
                        if (t.end == null || !t.end) {
                            t.end = t.start;
                        }
                        if (t.start == null || !t.start) {
                            t.start = t.end;
                        }
                    })
                    newProject.id = undefined;
                    newProject.projectTitle = props.projectName;
                    newProject.equipments = []; // let copy geo handle equipment
                    console.log("newProject");
                    console.log(newProject);
                    props.axios
                        .get(`${props.apiEndpoint}project/selectednsr/${props.targetProject.id}`).then(response => {
                            newProject.selectednsr = response.data;
                            console.log(newProject);

                            props.axios
                                .post(`https://web-cnmp.net/api/project`, DateHelper.fixUTCDate(newProject))
                                .then(function (response) {
                                    let targetProjectId = response.data.id;
                                    newProject.id = targetProjectId;
                                    props.axios
                                        .post(`https://web-cnmp.net/api/project/selectednsr`, DateHelper.fixUTCDate(newProject))
                                        .then(function (response) {
                                            MapOL.copyToProductionServer("zones", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("sites", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("sites2", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("buffers", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("buffers2", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("geomCenter", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("unregsites", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("unregbuffers", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("projectPME", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("projectNSRBuilding", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("projectNSRPoints", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("calculationresultnsr", sourceProjectId, targetProjectId)
                                            MapOL.copyToProductionServer("calculationresultdetail", sourceProjectId, targetProjectId)
                                        })
                                        .catch(error => console.log(error))
                                })
                                .catch(error => console.log(error))
                        })
                        .catch(error => console.log(error))
                })
                .catch(error => { console.log(error) })
        },
        copyToProduction2() {
            let sourceProjectId = this.targetProject.id;
        },
        confirmDeleteProject(event) {
            let props = this;
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Do you want to PERMANENTLY DELETE this project?',
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: () => {
                    props.deleteProject(props.targetProject);
                },
                reject: () => {

                }
            });
        },
        deleteProject(project) {
            let props = this;
            project.deleting = "pi pi-spin pi-spinner";
            this.axios
                .delete(`${this.apiEndpoint}project?id=${project.id}`)
                .then(response => {
                    let index = props.projects.map(p => p.projectTitleWithoutVersion).indexOf(project.projectTitleWithoutVersion);
                    if (index > -1) {
                        if (props.projects[index].versions.length > 1) {
                            let index2 = props.projects[index].versions.map(p => p.id).indexOf(project.id);
                            if (index2 > -1) {
                                props.projects[index].versions.splice(index2, 1);
                            }
                        }
                        else {
                            props.projects.splice(index, 1);
                        }
                    }
                    project.deleting = "pi pi-trash";
                    if (props.$store.getters.currentProject.id === project.id) {
                        window.onbeforeunload = null;
                        window.location.reload()
                    }
                })
                .catch((error) => {
                    console.log(error);
                    project.deleting = "pi pi-trash";
                })
        },
        getDateString(date) {
            return DateHelper.getDateString(date);
        },
        getDate(date) {
            return DateHelper.getDate(date);
        },
        updateProjectDate(newProject) {
            if (newProject.tasks.length > 0) {
                newProject.commencementDate = DateHelper.getDateString(new Date(
                    Math.min(
                        ...newProject.tasks.map(element => {
                            return DateHelper.getDate(element.start);
                        }),
                    ),
                ));
                newProject.completionDate = DateHelper.getDateString(new Date(
                    Math.max(
                        ...newProject.tasks.map(element => {
                            return DateHelper.getDate(element.end);
                        }),
                    ),
                ));
            }
            else {
                newProject.commencementDate = null;
                newProject.completionDate = null;
            }
            return newProject;
        },
    },
    mounted() {
    }
}
</script>

<style lang="less">
.dialog {
    width: 65vw;
    position: absolute;
    transform: translate(30%, 0%);
    top: 50px;
}
</style>
